import { useEffect, useRef } from 'react';
import apiClient from '@/services/apiClient';

// Keep a logged-in user marked ONLINE across the whole app — not just while the
// Internal Messenger is open. Fires on mount, every 20s, and whenever the tab
// becomes visible again, as long as a session token exists. A dropped/closed
// app stops pinging and the user naturally goes offline once the server-side
// presence TTL lapses.
const HEARTBEAT_MS = 20000;

export default function usePresenceHeartbeat() {
  const timerRef = useRef(null);

  useEffect(() => {
    const beat = () => {
      if (!localStorage.getItem('session_token')) return;
      apiClient.post('/messenger/heartbeat').catch(() => {});
    };

    beat();
    timerRef.current = setInterval(beat, HEARTBEAT_MS);

    const onVisible = () => {
      if (document.visibilityState === 'visible') beat();
    };
    document.addEventListener('visibilitychange', onVisible);

    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, []);
}
